<template>
    <div class="customer-service">
        <div class="pic">
            <img src="../assets/img/recruit-bg.jpg" alt="">
            <p>加入我们，一起开创财务的新未来</p>
            <el-button class="button" type="button" @click="dialogFormVisible = true">预约报名</el-button>

            <el-dialog title="预约报名" :visible.sync="dialogFormVisible">
                <el-form :model="groupform" :rules="rules" ref="groupform">
                    <el-form-item label="您的姓名" prop="name" :label-width="formLabelWidth">
                        <el-input v-model="groupform.name" placeholder="请输入真实姓名" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话" prop="mobile" :label-width="formLabelWidth">
                        <el-input v-model="groupform.mobile" placeholder="请输入联系电话" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="个人简介" prop="content" :label-width="formLabelWidth">
                        <el-input type="textarea" placeholder="例：会计师从事财务工作8年以上，具有全面的财务专业知识、财务处理及财务管理经验。曾任职于深圳市XXX科技公司财务主管，参与过XXX项目。" v-model="groupform.content"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="submitForm('groupform')">提交</el-button>
                </div>
            </el-dialog>
        </div>
        <div class="customer-main">
            <div class="word">
                <p>互联智能，推动劳力服务向知识服务转移，专业人员迎来了自由流动和创作的时代。分布在中小微企业1,200万财务从业者，缺少自由流动和创造激励的机制和平台，用户得不到响应时代变化的价值服务，从业人员收入和地位得不到提升。</p>
                <p>橙蟹为之而生，历经十年的披荆斩棘，时代的大变化，行业同仁的共同探讨，我们摸索出了一条实践之路。重新定义了从业人员应具备怎样的技能，采取怎样的运作方式，来服务客户的变化需求。一批分布不同行业，不同规模的忠实客户群，一系列适应不同性格，不同技能企业主的产品与服务，一支自营与平台顾问相互协同的营销与交付体系。
				</p>
                <p>我们需要更多具有创新思维的同行加入我们，一起开创财务的新未来。</p>
            </div>

            <h2>加入流程</h2>
            <div class="customer-pic">
                <img src="../assets/img/home－image－3.png" alt="">
            </div>
            <h2>财务顾问俱乐部</h2>
            <div class="customer-pic">
                <img src="../assets/img/gkk.jpg" alt="">
            </div>
            <h2>财务顾问“变形计”</h2>
            <div class="customer-pic">
                <img src="../assets/img/xly.jpg" alt="">
            </div>

            <h2>财务顾问团队<p>不仅需要好财务，更需要有价值的财务</p>
            </h2>
            <div class="group">
                <div class="groupEvety" v-for="(item,i) in groupList" :key="i" @mouseover="item.show = !item.show" @mouseout="item.show = !item.show">
                    <div class="groupImg">
                        <img :src="item.imgPath" alt="">
                        <div class="groupDetail" v-if="item.show">
                            <h3>{{item.title}}</h3>
                            <p>顾问级别：<span class="rank">{{item.rank}}</span></p>
                            <p>服务客户：{{item.client}}</p>
                            <p>顾问时长：{{item.duration}}</p>
                            <p>工作年限：{{item.workYears}}</p>
                            <p>资质证书：{{item.credential}}</p>
                        </div>
                    </div>
                </div>
            </div>
			<h2>往期回顾</h2>
            <div class="review">
                <el-row>
                    <el-col class="review-box" :span="7" v-for="item in reviewList" :key="item.reviewTrainId">
                        <div class="r-img">
                            <img :src="url+item.companyNewsImg" alt="">
                        </div>
                        <h4>{{item.title}}</h4>
                        <!-- <a :href="item.reviewTrainUrl" target="_blank">查看详情</a> -->
						<div @click="jump(item.companyNewsId)" class="detail">查看详情</div>
                    </el-col>
                </el-row>
                <div class="paging">
                    <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="9" background layout="total, prev, pager, next" :total="cententTotal">
                    </el-pagination>
                </div>
            </div>
            <!-- <h2>往期回顾</h2>
            <div class="review">
                <el-row>
                    <el-col class="review-box" :span="7" v-for="item in reviewList" :key="item.reviewTrainId">
                        <div class="r-img">
                            <img :src="url+item.reviewTrainImg" alt="">
                        </div>
                        <h4>{{item.title}}</h4>
                        <a :href="item.reviewTrainUrl" target="_blank">查看详情</a>
                    </el-col>
                </el-row>
                <div class="paging">
                    <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="9" background layout="total, prev, pager, next" :total="cententTotal">
                    </el-pagination>
                </div>
            </div> -->
        </div>

    </div>
</template>

<script>
import { revieWtrain, addConsultantJoin, companyNews } from '../api/api.js'
export default {
  name: 'customerService',
  created () {
    this.getPageList()
  },
  data () {
    return {
      url: 'http://121.40.191.9' + this.GLOBAL.picURL,
      groupList: [
        {
          imgPath: require('../assets/img/counselor－1.png'),
          title: '深谋远虑的大师顾问',
          rank: ' ★ ★ ★ ★ ★',
          client: '200+家',
          duration: '60月',
          workYears: '14年',
          credential: 'CPA/MBA',
          show: false
        },
        {
          imgPath: require('../assets/img/counselor－2.png'),
          title: '学霸型的知性顾问',
          rank: ' ★ ★ ★ ★ ★',
          client: '400+家',
          duration: '60月',
          workYears: '9年',
          credential: 'CPA/CMA/TA',
          show: false
        },
        {
          imgPath: require('../assets/img/counselor－4.png'),
          title: '百科型暖男顾问',
          rank: ' ★ ★ ★ ★ ',
          client: '43家',
          duration: '40月',
          workYears: '13年',
          credential: 'CMA',
          show: false
        },
        {
          imgPath: require('../assets/img/counselor－3.jpg'),
          title: '聪慧型的御姐顾问',
          rank: ' ★ ★ ★ ★ ',
          client: '100家',
          duration: '60月',
          workYears: '16年',
          credential: 'RFP',
          show: false
        },
        {
          imgPath: require('../assets/img/counselor－6.png'),
          title: '沉稳型的大叔顾问',
          rank: ' ★ ★ ★ ★ ',
          client: '150+家',
          duration: '60月',
          workYears: '26年',
          credential: 'CMA',
          show: false
        },
        {
          imgPath: require('../assets/img/counselor－5.png'),
          title: '睿智形的跑男顾问',
          rank: ' ★ ★ ★ ★',
          client: '86家',
          duration: '23月',
          workYears: '21年',
          credential: 'CMA/MBA',
          show: false
        },
        {
          imgPath: require('../assets/img/counselor－8.jpg'),
          title: '耐心型的率真顾问',
          rank: ' ★ ★ ★ ★  ',
		  client: '100+家',
          duration: '50月',
          workYears: '16年',
          credential: 'CPA/CMA',
          show: false
        },
        {
          imgPath: require('../assets/img/counselor－10.jpg'),
          title: '智慧型的才女顾问',
          rank: ' ★ ★ ★ ★ ★ ',
          client: '28家',
          duration: '36月',
          workYears: '19年',
          credential: 'CPA、SIFM',
          show: false
        },
        {
          imgPath: require('../assets/img/counselor－9.jpg'),
          title: '细致型的淑女顾问',
          rank: ' ★ ★ ★ ★',
          client: '35家',
          duration: '26月',
          workYears: '16年',
          credential: 'CPA',
          show: false
        },
        {
          imgPath: require('../assets/img/counselor－7.jpg'),
          title: '友善型的表姐顾问',
          rank: ' ★ ★ ★ ★ ★',
          client: '47家',
          duration: '12月',
          workYears: '23年',
          credential: 'CMA',
          show: false
        }

      ],
      reviewList: [],
      dialogFormVisible: false,
      groupform: {
        name: '',
        mobile: '',
        content: ''
      },
      formLabelWidth: '100px',
      rules: {
        name: [
          { required: true, message: '请输入您名字', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入您电话', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入您的简介', trigger: 'blur' }
        ]
      },
      // 分页器条件
      currentPage: 1,
      cententTotal: 0
    }
  },
  methods: {
    jump (id) {
      this.$router.push({ path: '/companyNewsDetail/' + id + '/2' })
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.dialogFormVisible = false
          addConsultantJoin(this.groupform).then(res => {
            if (res.status === 1) {
              this.$refs[formName].resetFields()
              this.$message({
                message: '预约成功',
                type: 'success'
              })
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleCurrentChange (val) {
      this.reviewList = []
      this.currentPage = val
      this.getPageList()
    },
    getPageList () {
      companyNews({
        pageNum: this.currentPage,
        pageSize: 6
      }).then(res => {
        console.log(res)
        this.cententTotal = res.data.data.total
        // for (let i = 0; i < res.data.data.list.length; i++) {
        //   if (res.data.data.list[i].reviewTrainStatus == '1') {
        //     this.reviewList.push(res.data.data.list[i])
        //   }
        // }
        this.reviewList = res.data.data.list
      })
    },
    toDetail (item) {
      console.log(item)
    }
  }
}
</script>

<style scoped>
    /* 图片 */
    .pic {
        width: 100%;
        height: 30%;
        text-align: center;
        position: relative;
    }

    .pic img {
        width: 100%;
        height: 100%;
    }

    .pic p {
        font-size: 34px;
        color: #ffffff;
        position: absolute;
        margin-top: -12%;
        margin-left: 37%;
    }

    .pic .button {
        position: absolute;
        background-color: #ff5112;
        color: #ffffff;
        margin-top: -8%;
        border: none;
    }

    /* 主体内容 */
    .customer-service .customer-main {
        width: 70%;
        padding: 0 15%;
        background-color: #f5f5f5;
    }

    .word p {
        padding-top: 2%;
        margin-bottom: 1%;
        color: #2e324f;
    }

    .customer-service h2 {
        color: #2e324f;
        font-size: 32px;
        text-align: center;
        padding: 3% 0;
    }

    h2 p {
        font-size: 14px;
        font-weight: normal;
    }

    .customer-pic {
        text-align: center;
        width: 65%;
        margin-left: 18%;
    }

    .customer-pic img {
        width: 100%;
    }

    /* 团队介绍 */
    .group .groupEvety {
        width: 18%;
        display: inline-block;
        margin-right: 2%;
        position: relative;
    }

    .groupImg img {
        width: 100%;
    }

    .groupEvety .groupDetail {
        background-color: #182246;
        width: 100%;
        color: #ffffff;
        position: absolute;
        transform: translateY(-170px);
        padding: 2% 0;
    }

    .groupDetail .rank {
        color: #ff5112;
    }

    .groupDetail h3 {
        text-align: center;
        padding: 3% 0;
    }

    .groupDetail p {
        padding: 0 10%;
    }

    @media screen and (max-width: 1470px) {
        .groupDetail p {
            font-size: 12px;
        }
    }

    /* 往期回顾 */
    .review-box {
        margin: 0 2% 2%;
        background-color: #ffffff;
		/* min-height: 396px; */
    }

    .paging {
        text-align: center;
    }

    /* .r-img{
    width: 100%;
    height: 100%;
} */
    .r-img img {
        width: 100%;
        height: 100%;
		height: 240px;
    }

    .review h4 {
        height: 54px;
        padding: 1% 1%;
        margin: 4% 4%;
        font-size: 18px;
        color: #2e324f;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    /* .review h4:hover{
    display: block;
            width: 90%;
            overflow: auto;
            white-space: normal;
} */
    .review .detail {
        display: inline-block;
        width: 30%;
        padding: 2% 2%;
        margin: 2% 4%;
        color: #2e324f;
        border: 1px solid #2e324f;
        border-radius: 5px;
        font-size: 16px;
        text-align: center;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/advisersRecruited.vue